import React from 'react';
import './scss/About.scss';

const About: React.FC = () => {
  const stats = [
    { value: '15+', label: 'Years Experience' },
    { value: '200K+', label: 'Live Participants Supported' },
    { value: '100+', label: 'Enterprise Clients' },
    { value: '21% to 92%', label: 'Compliance Improvement' }
  ];

  const highlights = [
    {
      icon: 'fas fa-cloud',
      title: 'Pre-Sales Architecture',
      description: 'Translate business requirements into secure, replicable cloud architectures, technical PoCs, and practical implementation blueprints.'
    },
    {
      icon: 'fas fa-cogs',
      title: 'Secure AI Platforms',
      description: 'Design AI platforms with network segmentation, Private Endpoints, WAF, identity governance, and secure enterprise integrations.'
    },
    {
      icon: 'fas fa-industry',
      title: 'Cloud & Hybrid Infrastructure',
      description: 'Architect Azure, AWS, and hybrid foundations using landing zones, private connectivity, managed identities, and scalable services.'
    },
    {
      icon: 'fas fa-users',
      title: 'Partner Enablement',
      description: 'Facilitate large-scale technical workshops and provide governance playbooks that help partners and engineering teams deliver confidently.'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        
        <div className="about-content">
          <div className="about-text">
            <div className="about-intro">
              <p>
                I am a pre-sales focused Partner Solution Architect and senior technology leader with over 15 years of experience translating complex enterprise business requirements into scalable, replicable cloud architectures.
              </p>
              <p>
                My domain specialization sits at the intersection of infrastructure, cloud security, and artificial intelligence. I design secure AI platforms, RAG solutions, hybrid connectivity, identity governance, and modern application foundations across Azure, AWS, and enterprise environments.
              </p>
              <p>
                I lead technical proofs-of-concept, C-level presentations, architecture workshops, partner enablement, and ecosystem strategy. My approach connects business value with clear technical decisions and delivery-ready governance.
              </p>
              <p>
                I help system integrators and engineering teams build future-proof foundations while deflecting post-sales delivery risks through well-architected blueprints, security controls, monitoring requirements, and clear implementation sequencing.
              </p>
            </div>

            <div className="stats-grid">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <span className="stat-value">{stat.value}</span>
                  <span className="stat-label">{stat.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="about-highlights">
            <h3>What I Bring</h3>
            <div className="highlights-grid">
              {highlights.map((highlight, index) => (
                <div key={index} className="highlight-card">
                  <div className="highlight-icon">
                    <i className={highlight.icon}></i>
                  </div>
                  <div className="highlight-content">
                    <h4>{highlight.title}</h4>
                    <p>{highlight.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
